import { configOption, KahunConfigurationOptionType } from "../lib/annotations";
import { MessageTemplate } from "./messageTemplate";

export class SmsOptions {
  @configOption({
    description: "Is this option enabled from the ui",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  enabled: boolean = true;

  @configOption({
    description: "The from number we use to send the SMS",
  })
  from: string;

  @configOption({
    description: "List of templated per-touch point",
    displayType: KahunConfigurationOptionType.MessageTemplate,
  })
  templates: MessageTemplate[];
}
